<template>
  <div class="general-form mx-4 col-lg-4 col-md-6 col-sm-10">
    <b-form-group class="form-group_center" label="Display map labels by default" label-cols="4" label-cols-sm="8">
      <b-form-checkbox
        type="checkbox"
        v-model="settings.general_map_tooltip_default_display"
        :disabled="saving || !canControl"
        @change="saveSettings('general_map_tooltip_default_display')"
      />
    </b-form-group>
    <b-form-group class="form-group_center" label="Icons zoom scaling" label-cols="4" label-cols-sm="8">
      <b-form-checkbox
        type="checkbox"
        v-model="settings.general_map_points_zoom_scaling"
        :disabled="saving || !canControl"
        @change="saveSettings('general_map_points_zoom_scaling')"
      />
    </b-form-group>
    <b-form-group v-if="settings.general_map_points_zoom_scaling" label="Icons zoom scaling factor" label-cols="4" label-cols-sm="8">
      <b-form-input
        type="number"
        min="0.5"
        max="3"
        v-model.number="settings.general_map_points_zoom_scaling_factor"
        :disabled="saving || !canControl"
        @blur="saveSettings('general_map_points_zoom_scaling_factor')"
      />
    </b-form-group>
    <b-form-group
      label="Max desk booking days (0 = unlimited)"
      label-cols="4"
      label-cols-sm="8"
      description="Takes effect for users without Desk Infinity Booking permission"
    >
      <b-form-input
        type="number"
        min="0"
        v-model.number="settings.general_max_days_desk_booking_limit"
        :disabled="saving || !canControl"
        @blur="saveSettings('general_max_days_desk_booking_limit')"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'General',
  data: () => ({
    saving: false,
  }),
  computed: {
    ...mapState('settings', ['generalSettings']),
    ...mapGetters('settings', ['canControl']),
    settings: {
      get() { return this.generalSettings },
      set(settings) { this.setGeneralSettings(settings) }
    }
  },
  methods: {
    ...mapMutations('settings', ['setGeneralSettings']),
    ...mapActions('settings', ['saveGeneralSettings', 'loadGeneralSettings']),
    async saveSettings(field) {
      try {
        this.saving = true
        await this.saveGeneralSettings({ [field]: this.settings[field] })
      } catch (e) {
        await this.loadGeneralSettings()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
